import BarsSVG from "../BarsSVG";
import BinocularsSVG from "../BinocularsSVG";
import CircleDiagramSVG from "../CircleDiagramSVG";
import ContractSVG from "../ContractSVG";
import EGKSVG from "../EGKSVG";
import HealthSVG from "../HealthSVG";
import PyramidSVG from "../PyramidSVG";
import SpiderchartSVG from "../SpiderchartSVG";
import TacticSVG from "../TacticSVG";
import TargetSVG from "../TargetSVG";
import TrainingSVG from "../Training.VG";

export type Feature = {
  label: string;
  buttonStyleClass: string;
  icon: JSX.Element;
  headline: string;
  description: string;
};

export const featureList: Feature[] = [
  {
    icon: <SpiderchartSVG />,
    label: "Leistungsmetriken",
    buttonStyleClass: "round-button-dark",
    headline: "Leistungsmetriken und Vorhersagemodelle",
    description:
      "KI bewertet Spieler objektiv anhand von Schlüsselmetriken wie Schussgenauigkeit, Geschwindigkeit, Passgenauigkeit und defensiven Fähigkeiten. Dadurch lassen sich Spieler miteinander vergleichen und zukünftige Entwicklungen vorhersagen. Durch die Analyse historischer Daten und Trends können Trainer und Vereine fundierte Entscheidungen über die zukünftige Rolle und das Potenzial eines Spielers treffen.",
  },
  {
    icon: <TargetSVG />,
    label: "Talentsuche",
    buttonStyleClass: "round-button-primary",
    headline:
      "Talentsuche und Rekrutierung: Entdecken Sie die Stars von morgen.",
    description:
      "Die KI-gestützte Scouting-Datenbank ermöglicht es, weltweit Spielerprofile zu analysieren und versteckte Talente zu identifizieren. Spieler mit hohem Entwicklungspotenzial, die möglicherweise unter dem Radar fliegen, werden frühzeitig erkannt. Dies eröffnet Ihrem Verein neue Möglichkeiten in der Talentrekrutierung.",
  },
  {
    icon: <TacticSVG />,
    label: "Taktik",
    buttonStyleClass: "round-button-primary",
    headline: "Taktische Insights für den Erfolg",
    description:
      "Unsere Plattform schlägt individuelle Strategien vor, um gegnerische Schlüsselspieler zu neutralisieren und bietet datengestützte Empfehlungen für das Spiel. Dies verschafft Ihrem Team einen klaren Wettbewerbsvorteil.",
  },
  {
    icon: <BarsSVG />,
    label: "Wettbewerbsvorteile",
    buttonStyleClass: "round-button-dark",
    headline: "Wettbewerbsvorteile durch datenbasierte Insights",
    description:
      "Nutzen Sie die Möglichkeiten moderner KI, um fundierte, objektive Entscheidungen über Transfers, Taktiken und Trainingspläne zu treffen. Optimieren Sie Ihren Kader, minimieren Sie Verletzungsrisiken und steigern Sie die Leistung Ihres Teams – alles durch die Skalierbarkeit und Zuverlässigkeit der AWS-Cloud-Dienste.",
  },
  {
    icon: <BinocularsSVG />,
    label: "Gegnerscouting",
    buttonStyleClass: "round-button-light",
    headline: "Gegnerscouting: Erfolgsstrategie durch präzise Analyse",
    description:
      "Neben der Bewertung eigener Spieler ermöglicht die Plattform detaillierte Analysen von gegnerischen Teams und Spielern. Stärken und Schwächen des Gegners werden durch Datenanalysen aufgedeckt, und KI liefert taktische Empfehlungen, um optimal auf das nächste Spiel vorbereitet zu sein.",
  },
  {
    icon: <CircleDiagramSVG />,
    label: "Potentialanalyse",
    buttonStyleClass: "round-button-light",
    headline: "Potentialanalyse für die Zukunft ",
    description:
      "Durch die Analyse von Leistungsdaten und Wachstumskurven identifiziert die Plattform Spieler, die das Potenzial haben, sich in Zukunft zu Schlüsselspielern zu entwickeln.",
  },
  {
    icon: <EGKSVG />,
    label: "Erholungsmanagement",
    buttonStyleClass: "round-button-dark",
    headline: "Effizientes Erholungsmanagement",
    description:
      "Nach Verletzungen bietet die Plattform maßgeschneiderte Empfehlungen für das Erholungsmanagement, um eine optimale Rückkehr ins Training und auf das Spielfeld zu gewährleisten.",
  },
  {
    icon: <PyramidSVG />,
    label: "Kosten-Nutzen-Analyse",
    buttonStyleClass: "round-button-primary",
    headline:
      "Kosten-Nutzen-Analyse: Fundierte Entscheidungen für Transfers und Verträge",
    description:
      "Durch die Analyse von Leistungs- und Marktdaten kann die Plattform objektive Bewertungen für Transfers und Vertragsverhandlungen liefern. Kosten-Nutzen-Analysen bieten einen Überblick über die potenzielle Leistung eines Spielers im Verhältnis zu den anfallenden Transfer- und Gehaltskosten.",
  },
  {
    icon: <ContractSVG />,
    label: "Vertragsverhandlungen",
    buttonStyleClass: "round-button-dark",
    headline: "Optimierte Vertragsverhandlungen",
    description:
      "Mit Hilfe von historischen Marktwertentwicklungen vergleichbarer Spieler liefert die Plattform faire und datenbasierte Vertragsangebote.",
  },
  {
    icon: <TrainingSVG />,
    label: "Trainingspläne",
    buttonStyleClass: "round-button-light",
    headline:
      "Personalisierte Trainingspläne: Maximieren Sie das Leistungspotenzial Ihrer Spieler",
    description:
      "Unsere Plattform erstellt auf Basis individueller Leistungsanalysen personalisierte Trainingspläne für jeden Spieler. Dies ermöglicht gezielte Verbesserung von spezifischen Fähigkeiten und trägt zur nachhaltigen Leistungssteigerung bei.",
  },
  {
    icon: (
      <div className="bg-neutralDark p-1 rounded-[50%]">
        <HealthSVG />
      </div>
    ),
    label: "Verletzungsprävention",
    buttonStyleClass: "round-button-accent",
    headline: "Verletzungsprävention und -management: Spieler gesund halten",
    description:
      "Die Plattform bietet auch Lösungen zur Risikobewertung und Verletzungsprävention. Durch die Analyse von physischen Belastungsdaten und Trainingsintensität kann das Verletzungsrisiko von Spielern ermittelt und durch Anpassungen im Trainingsplan minimiert werden. So werden unnötige Ausfallzeiten verhindert.",
  },
];
